import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.14.1592_@types+node@20.19.43_db0@0.3.4_eslint@9.39.5_jiti@1.21.7__ioredis@5.11.1_magic_wdymvkjqav3scy37r4rd7at6wm/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}